import axios from "axios";
import {
  CONSERVATION_CREATION,
  CONSERVATION_NEXT,
  CONSERVATION_DETAILS,
  CREATE_OBJECT,
  DELETE_OBJECT,
  LIST_OBJECT_URL,
  OBJECT_DROPDOWN_URL,
  OBJECT_SINGLE_DETAIL,
  TREATMENT_CREATION,
  TREATMENT_DROPDOWN,
  OBJECT_BULK_UPLOAD,
  CONSERVATION_STATUS,
  BULK_ACCESS,
  BULK_ACCESSION_LIST,
  DEGRADATION_DROPDOWN,
  TABLE_CHANGE,
  ASSIGN_USER,
  EXPORT_LIST,
  CREATE_GLB,
  NEXT_AND_PREVIOUS,
  CREATE_PIN_OBJECT,
  GET_PIN_OBJECT_LIST,
  DELETE_PIN_OBJECT,
  GET_PIN_PAGE_LIST,
  BASIC_INFORMATION_OBJECT,
  CREATE_DIGITAL,
  CREATE_SESSION,
  CANCEL_SESSION,
} from "../api";
import axiosInstance from "../axiosInstance";

export const createObject = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_OBJECT, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const createPhotography = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_DIGITAL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const createSession = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_SESSION, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const cancelSession = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CANCEL_SESSION, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const createGlb = (props) => (onResponse) => {
  for (let [key, value] of props.entries()) {
    console.log(
      `${key}:`,
      value,

      "glbprop"
    );
  }

  try {
    axiosInstance
      .put(CREATE_GLB, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const listObject = (props) => (onResponse) => {
  console.log(props?.transit_room, "transitrooms");

  try {
    let BASE_URL = LIST_OBJECT_URL + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.is_information_pending) {
      BASE_URL +=
        "is_information_pending=" + props.is_information_pending + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.category) {
      BASE_URL += "category=" + props.category + "&";
    }
    if (props.collection_is_draft) {
      BASE_URL += "collection_is_draft=" + props.collection_is_draft + "&";
    }
    if (props?.conservation_is_draft) {
      BASE_URL += "conservation_is_draft=" + props.conservation_is_draft + "&";
    }
    if (props.is_iconic) {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    } else if (props.is_iconic === false) {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    }
    if (props.is_drive_link) {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    } else if (props.is_drive_link === false) {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    }
    if (props.material) {
      BASE_URL += "material=" + props.material + "&";
    }
    if (props.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props?.conservation_status) {
      BASE_URL += "conservation_status=" + props.conservation_status + "&";
    }
    if (props?.collection_completed) {
      BASE_URL += "collection_completed=" + props.collection_completed + "&";
    }
    if (props?.photography_completed) {
      BASE_URL += "photography_completed=" + props.photography_completed + "&";
    }
    if (props?.is_image) {
      BASE_URL += "is_image=" + props.is_image + "&";
    } else if (props?.is_image === false) {
      BASE_URL += "is_image=" + props.is_image + "&";
    }
    if (props?.room) {
      BASE_URL += "room=" + props.room + "&";
    }
    if (props?.transit_room) {
      BASE_URL += "transit_room=" + props.transit_room + "&";
    }
    if (props?.created_by) {
      BASE_URL += "created_by=" + props.created_by + "&";
    }
    if (props?.height_min) {
      BASE_URL += "height_min=" + props.height_min + "&";
    }
    if (props?.height_max) {
      BASE_URL += "height_max=" + props.height_max + "&";
    }
    if (props?.width_min) {
      BASE_URL += "width_min=" + props.width_min + "&";
    }
    if (props?.width_max) {
      BASE_URL += "width_max=" + props.width_max + "&";
    }
    if (props?.depth_min) {
      BASE_URL += "depth_min=" + props.depth_min + "&";
    }
    if (props?.depth_max) {
      BASE_URL += "depth_max=" + props.depth_max + "&";
    }
    if (props?.period_start) {
      BASE_URL += "period_start=" + props.period_start + "&";
    }
    if (props?.period_end) {
      BASE_URL += "period_end=" + props.period_end + "&";
    }
    if (props?.modified_start_date) {
      BASE_URL += "modified_start_date=" + props.modified_start_date + "&";
    }
    if (props?.modified_end_date) {
      BASE_URL += "modified_end_date=" + props.modified_end_date + "&";
    }
    if (props?.tags) {
      BASE_URL += "tags=" + props.tags + "&";
    }
    if (props?.acquisition_method) {
      BASE_URL += "acquisition_method=" + props.acquisition_method + "&";
    }
    if (props?.conservation_grade) {
      BASE_URL += "conservation_grade=" + props.conservation_grade + "&";
    }
    if (props?.is_emergency) {
      BASE_URL += "is_emergency=" + props.is_emergency + "&";
    }
    if (props?.photography_status) {
      BASE_URL += "photography_status=" + props.photography_status + "&";
    }
    if (props?.object_assigned) {
      BASE_URL += "object_assigned=" + props.object_assigned + "&";
    }
    if (props?.period) {
      BASE_URL += "period=" + props.period + "&";
    }
    if (props?.primary_category) {
      BASE_URL += "primary_category=" + props.primary_category + "&";
    }
    if (props?.transit_room?.length > 0) {
      BASE_URL += "transit_room=" + props.transit_room + "&";
    }
    if (props?.is_pinned) {
      BASE_URL += "is_pinned=" + props.is_pinned + "&";
    }
    if (props?.remarks) {
      BASE_URL += "remarks=" + props.remarks + "&";
    } else if (props?.remarks === false) {
      BASE_URL += "remarks=" + props.remarks + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const getSingleObject = (props) => (onResponse) => {
  try {
    let BASE_URL = OBJECT_SINGLE_DETAIL + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.id) {
      BASE_URL += "id=" + props.id + "&";
    }
    if (props?.is_photography_screen) {
      BASE_URL += "is_photography_screen=" + props.is_photography_screen + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const DeleteObject = (props) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_OBJECT, { data: { id: props?.id } })
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const listObjectDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = OBJECT_DROPDOWN_URL + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.room) {
      BASE_URL += "room=" + props.room + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }

    if (props.is_collection_completed) {
      BASE_URL +=
        "is_collection_completed=" + props.is_collection_completed + "&";
    }
    if (props.category) {
      BASE_URL += "category=" + props.category + "&";
    }
    if (props.primary_category) {
      BASE_URL += "primary_category=" + props.primary_category + "&";
    }
    if (props.material) {
      BASE_URL += "material=" + props.material + "&";
    }
    if (props.is_information_pending) {
      BASE_URL +=
        "is_information_pending=" + props.is_information_pending + "&";
    } else if (props.is_information_pending === false) {
      BASE_URL +=
        "is_information_pending=" + props.is_information_pending + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const exportObjectList = (props) => (onResponse) => {
  try {
    let BASE_URL = EXPORT_LIST + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.is_information_pending) {
      BASE_URL +=
        "is_information_pending=" + props.is_information_pending + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.category) {
      BASE_URL += "category=" + props.category + "&";
    }
    if (props.collection_is_draft) {
      BASE_URL += "collection_is_draft=" + props.collection_is_draft + "&";
    }
    if (props?.conservation_is_draft) {
      BASE_URL += "conservation_is_draft=" + props.conservation_is_draft + "&";
    }
    if (props.is_iconic) {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    } else {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    }
    if (props.is_drive_link) {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    } else {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    }
    if (props.material) {
      BASE_URL += "material=" + props.material + "&";
    }
    if (props.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props?.conservation_status) {
      BASE_URL += "conservation_status=" + props.conservation_status + "&";
    }
    if (props?.collection_completed) {
      BASE_URL += "collection_completed=" + props.collection_completed + "&";
    }
    if (props?.photography_completed) {
      BASE_URL += "photography_completed=" + props.photography_completed + "&";
    }
    if (props?.is_image) {
      BASE_URL += "is_image=" + props.is_image + "&";
    } else {
      BASE_URL += "is_image=" + props.is_image + "&";
    }
    if (props?.room) {
      BASE_URL += "room=" + props.room + "&";
    }
    if (props?.created_by) {
      BASE_URL += "created_by=" + props.created_by + "&";
    }
    if (props?.height_min) {
      BASE_URL += "height_min=" + props.height_min + "&";
    }
    if (props?.height_max) {
      BASE_URL += "height_max=" + props.height_max + "&";
    }
    if (props?.width_min) {
      BASE_URL += "width_min=" + props.width_min + "&";
    }
    if (props?.width_max) {
      BASE_URL += "width_max=" + props.width_max + "&";
    }
    if (props?.depth_min) {
      BASE_URL += "depth_min=" + props.depth_min + "&";
    }
    if (props?.depth_max) {
      BASE_URL += "depth_max=" + props.depth_max + "&";
    }
    if (props?.period_start) {
      BASE_URL += "period_start=" + props.period_start + "&";
    }
    if (props?.period_end) {
      BASE_URL += "period_end=" + props.period_end + "&";
    }
    if (props?.modified_start_date) {
      BASE_URL += "modified_start_date=" + props.modified_start_date + "&";
    }
    if (props?.modified_end_date) {
      BASE_URL += "modified_end_date=" + props.modified_end_date + "&";
    }
    if (props?.tags) {
      BASE_URL += "tags=" + props.tags + "&";
    }
    if (props?.acquisition_method) {
      BASE_URL += "acquisition_method=" + props.acquisition_method + "&";
    }
    if (props?.conservation_grade) {
      BASE_URL += "conservation_grade=" + props.conservation_grade + "&";
    }
    if (props?.is_emergency) {
      BASE_URL += "is_emergency=" + props.is_emergency + "&";
    }
    if (props?.photography_status) {
      BASE_URL += "photography_status=" + props.photography_status + "&";
    }
    if (props?.object_assigned) {
      BASE_URL += "object_assigned=" + props.object_assigned + "&";
    }
    if (props?.remarks) {
      BASE_URL += "remarks=" + props.remarks + "&";
    } else if (props?.remarks === false) {
      BASE_URL += "remarks=" + props.remarks + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const objectConservationCreation = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CONSERVATION_CREATION, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

export const getObjectConservationDetails = (props) => (onResponse) => {
  try {
    let BASE_URL = CONSERVATION_DETAILS + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.id) {
      BASE_URL += "id=" + props.id + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

export const objectConservationStatus = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(CONSERVATION_STATUS, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

// export const bulksampledownloadhandler = (props) => onResponse => {
//     try {
//         axiosInstance.get(CATEGORY_CSV_SAMPLE, props)
//             .then((response) => {
//                 // console.log(response)
//                 onResponse(response.data);
//             })
//             .catch((err) => {
//                 console.log(err)
//                 onResponse(err);
//             });

//     } catch (error) {

//     }

// };

export const uploadBulkobjectHandler = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(OBJECT_BULK_UPLOAD, props?.values)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const objectTreatmentCreation = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(TREATMENT_CREATION, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

export const listTreatmentDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = TREATMENT_DROPDOWN + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const detailNextDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = CONSERVATION_NEXT + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.museum_object) {
      BASE_URL += "museum_object=" + props.museum_object + "&";
    }
    if (props.conservation_status) {
      BASE_URL += "conservation_status=" + props.conservation_status + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.photography_status) {
      BASE_URL += "photography_status=" + props.photography_status + "&";
    }
    // if (props.is_status_changed) {
    //     BASE_URL += 'is_status_changed=' + props.is_status_changed + '&'
    // } else {
    //     BASE_URL += 'is_status_changed=' + props.is_status_changed + '&'
    // }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        console.log(response);
        onResponse(response?.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const objectbulk = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CONSERVATION_CREATION, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

export const objectBulkAccessCreation = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(BULK_ACCESS, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

export const listAccessBulk = (props) => (onResponse) => {
  try {
    let BASE_URL = BULK_ACCESSION_LIST + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.museum) {
      BASE_URL += "museum=" + props.museum + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const listDegradationDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = DEGRADATION_DROPDOWN + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.object_id) {
      BASE_URL += "object_id=" + props.object_id + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};
export const objectTableEditHandler = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(TABLE_CHANGE, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

export const assignUser = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(ASSIGN_USER, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((errr) => {
        onResponse(errr?.response?.data);
      });
  } catch (error) {}
};

export const nextAndPreviousHandler = (props) => (onResponse) => {
  console.log(props, "nextprops");

  try {
    let BASE_URL = NEXT_AND_PREVIOUS + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.is_information_pending) {
      BASE_URL +=
        "is_information_pending=" + props.is_information_pending + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.category) {
      BASE_URL += "category=" + props.category + "&";
    }
    if (props.collection_is_draft) {
      BASE_URL += "collection_is_draft=" + props.collection_is_draft + "&";
    }
    if (props?.conservation_is_draft) {
      BASE_URL += "conservation_is_draft=" + props.conservation_is_draft + "&";
    }
    if (props.is_iconic) {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    } else if (props.is_iconic === false) {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    }
    if (props.is_drive_link) {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    } else if (props.is_drive_link === false) {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    }
    if (props.material) {
      BASE_URL += "material=" + props.material + "&";
    }
    if (props.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props?.conservation_status) {
      BASE_URL += "conservation_status=" + props.conservation_status + "&";
    }
    if (props?.collection_completed) {
      BASE_URL += "collection_completed=" + props.collection_completed + "&";
    }
    if (props?.photography_completed) {
      BASE_URL += "photography_completed=" + props.photography_completed + "&";
    }
    if (props?.is_image) {
      BASE_URL += "is_image=" + props.is_image + "&";
    } else if (props?.is_image === false) {
      BASE_URL += "is_image=" + props.is_image + "&";
    }
    if (props?.room) {
      BASE_URL += "room=" + props.room + "&";
    }
    if (props?.created_by) {
      BASE_URL += "created_by=" + props.created_by + "&";
    }
    if (props?.height_min) {
      BASE_URL += "height_min=" + props.height_min + "&";
    }
    if (props?.height_max) {
      BASE_URL += "height_max=" + props.height_max + "&";
    }
    if (props?.width_min) {
      BASE_URL += "width_min=" + props.width_min + "&";
    }
    if (props?.width_max) {
      BASE_URL += "width_max=" + props.width_max + "&";
    }
    if (props?.depth_min) {
      BASE_URL += "depth_min=" + props.depth_min + "&";
    }
    if (props?.depth_max) {
      BASE_URL += "depth_max=" + props.depth_max + "&";
    }
    if (props?.period_start) {
      BASE_URL += "period_start=" + props.period_start + "&";
    }
    if (props?.period_end) {
      BASE_URL += "period_end=" + props.period_end + "&";
    }
    if (props?.modified_start_date) {
      BASE_URL += "modified_start_date=" + props.modified_start_date + "&";
    }
    if (props?.modified_end_date) {
      BASE_URL += "modified_end_date=" + props.modified_end_date + "&";
    }
    if (props?.tags) {
      BASE_URL += "tags=" + props.tags + "&";
    }
    if (props?.acquisition_method) {
      BASE_URL += "acquisition_method=" + props.acquisition_method + "&";
    }
    if (props?.conservation_grade) {
      BASE_URL += "conservation_grade=" + props.conservation_grade + "&";
    }
    if (props?.is_emergency) {
      BASE_URL += "is_emergency=" + props.is_emergency + "&";
    }
    if (props?.photography_status) {
      BASE_URL += "photography_status=" + props.photography_status + "&";
    }
    if (props?.object_assigned) {
      BASE_URL += "object_assigned=" + props.object_assigned + "&";
    }
    if (props?.period) {
      BASE_URL += "period=" + props.period + "&";
    }
    if (props?.primary_category) {
      BASE_URL += "primary_category=" + props.primary_category + "&";
    }
    if (props?.current_object) {
      BASE_URL += "current_object=" + props.current_object + "&";
    }
    if (props?.screen) {
      BASE_URL += "screen=" + props.screen + "&";
    }
    if (props?.is_global_search) {
      BASE_URL += "is_global_search=" + props.is_global_search + "&";
    } else if (props?.is_global_search === false) {
      BASE_URL += "is_global_search=" + props.is_global_search + "&";
    }
    if (props?.kanban_status) {
      BASE_URL += "kanban_status=" + props.kanban_status + "&";
    }
    if (props?.is_pinned) {
      BASE_URL += "is_pinned=" + props.is_pinned + "&";
    }
    if (props?.remarks) {
      BASE_URL += "remarks=" + props.remarks + "&";
    } else if (props?.remarks === false) {
      BASE_URL += "remarks=" + props.remarks + "&";
    }
    if (props?.transit_room) {
      BASE_URL += "transit_room=" + props.transit_room + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const addPinObject = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_PIN_OBJECT, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const getPinnedObjectList = (props) => (onResponse) => {
  try {
    let BASE_URL = GET_PIN_OBJECT_LIST + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props?.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props?.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props?.museum) {
      BASE_URL += "museum=" + props.museum + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const deletePinObject = (props) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_PIN_OBJECT, { data: { id: props?.id } })
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const objectPinPageList = (props) => (onResponse) => {
  console.log(props, "ispinned");

  try {
    let BASE_URL = GET_PIN_PAGE_LIST + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.is_information_pending) {
      BASE_URL +=
        "is_information_pending=" + props.is_information_pending + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.category) {
      BASE_URL += "category=" + props.category + "&";
    }
    if (props.collection_is_draft) {
      BASE_URL += "collection_is_draft=" + props.collection_is_draft + "&";
    }
    if (props?.conservation_is_draft) {
      BASE_URL += "conservation_is_draft=" + props.conservation_is_draft + "&";
    }
    if (props.is_iconic) {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    } else if (props.is_iconic === false) {
      BASE_URL += "is_iconic=" + props.is_iconic + "&";
    }
    if (props.is_drive_link) {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    } else if (props.is_drive_link === false) {
      BASE_URL += "is_drive_link=" + props.is_drive_link + "&";
    }
    if (props.material) {
      BASE_URL += "material=" + props.material + "&";
    }
    if (props.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    if (props?.conservation_status) {
      BASE_URL += "conservation_status=" + props.conservation_status + "&";
    }
    if (props?.collection_completed) {
      BASE_URL += "collection_completed=" + props.collection_completed + "&";
    }
    if (props?.photography_completed) {
      BASE_URL += "photography_completed=" + props.photography_completed + "&";
    }
    if (props?.is_image) {
      BASE_URL += "is_image=" + props.is_image + "&";
    } else if (props?.is_image === false) {
      BASE_URL += "is_image=" + props.is_image + "&";
    }
    if (props?.room) {
      BASE_URL += "room=" + props.room + "&";
    }
    if (props?.created_by) {
      BASE_URL += "created_by=" + props.created_by + "&";
    }
    if (props?.height_min) {
      BASE_URL += "height_min=" + props.height_min + "&";
    }
    if (props?.height_max) {
      BASE_URL += "height_max=" + props.height_max + "&";
    }
    if (props?.width_min) {
      BASE_URL += "width_min=" + props.width_min + "&";
    }
    if (props?.width_max) {
      BASE_URL += "width_max=" + props.width_max + "&";
    }
    if (props?.depth_min) {
      BASE_URL += "depth_min=" + props.depth_min + "&";
    }
    if (props?.depth_max) {
      BASE_URL += "depth_max=" + props.depth_max + "&";
    }
    if (props?.period_start) {
      BASE_URL += "period_start=" + props.period_start + "&";
    }
    if (props?.period_end) {
      BASE_URL += "period_end=" + props.period_end + "&";
    }
    if (props?.modified_start_date) {
      BASE_URL += "modified_start_date=" + props.modified_start_date + "&";
    }
    if (props?.modified_end_date) {
      BASE_URL += "modified_end_date=" + props.modified_end_date + "&";
    }
    if (props?.tags) {
      BASE_URL += "tags=" + props.tags + "&";
    }
    if (props?.acquisition_method) {
      BASE_URL += "acquisition_method=" + props.acquisition_method + "&";
    }
    if (props?.conservation_grade) {
      BASE_URL += "conservation_grade=" + props.conservation_grade + "&";
    }
    if (props?.is_emergency) {
      BASE_URL += "is_emergency=" + props.is_emergency + "&";
    }
    if (props?.photography_status) {
      BASE_URL += "photography_status=" + props.photography_status + "&";
    }
    if (props?.object_assigned) {
      BASE_URL += "object_assigned=" + props.object_assigned + "&";
    }
    if (props?.period) {
      BASE_URL += "period=" + props.period + "&";
    }
    if (props?.primary_category) {
      BASE_URL += "primary_category=" + props.primary_category + "&";
    }
    if (props?.is_pinned) {
      BASE_URL += "is_pinned=" + props.is_pinned + "&";
    }
    if (props?.transit_room) {
      BASE_URL += "transit_room=" + props.transit_room + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const getBasicInformation = (props) => (onResponse) => {
  console.log(props, "transitBasicprops");

  try {
    axiosInstance
      .post(BASIC_INFORMATION_OBJECT, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {
    console.log(err);
  }
};
